import { Box } from '@customink/pigment-react';
import { useRef } from 'react';
import type { CSSProperties, MouseEventHandler } from 'react';

export default function Image({
  onClick,
  src,
  style,
}: {
  onClick?: MouseEventHandler;
  src?: string;
  style?: CSSProperties;
}) {
  const imageRef = useRef<HTMLImageElement>(null);

  if (!src) return <Box data-testid="image-error-empty-div"></Box>;

  return (
    <img
      alt="design proof"
      data-testid="image"
      loading="lazy"
      onClick={onClick}
      ref={imageRef}
      src={src}
      style={style}
    />
  );
}
